/* mediaファセット一覧ナビ
   1) 無限スクロール: SSR 20件 → bootstrap埋め込み60件 → csr-index（テーマアセット）から続き
      発火は IntersectionObserver + scroll/resize フォールバックの二重化（IO単独は環境により不発）。
      ?p= はビューポート連動（上に戻れば戻り、先頭で消える。?p=N 直開きはNバッチ展開+位置復元）。
   2) 絞り込み: 単一タグ選択=実在ページへ遷移（manifest照合）/ 複数タグ=その場CSR（OR・?f= 反映）
   カードDOMは snippets/media-facet-card.liquid と同一構造を保つこと。 */
(function () {
  'use strict';
  var bootEl = document.getElementById('mfct-bootstrap');
  if (!bootEl) return;
  var B;
  try { B = JSON.parse(bootEl.textContent); } catch (e) { return; }

  var grid = document.getElementById('mfct-list-grid');
  var sentinel = document.getElementById('mfct-sentinel');
  var csrSentinel = document.getElementById('mfct-csr-sentinel');
  var listNote = document.getElementById('mfct-list-note');
  var ssrWrap = document.getElementById('mfct-ssr');
  var csrWrap = document.getElementById('mfct-csr');
  var csrGrid = document.getElementById('mfct-csr-grid');
  var csrNote = document.getElementById('mfct-csr-note');
  var statusEl = document.getElementById('mfct-filter-status');
  if (!grid || !sentinel) return;

  var DEBUG = !!window.MFCT_DEBUG;
  function log() { if (DEBUG && window.console) console.log.apply(console, ['[mfct]'].concat([].slice.call(arguments))); }

  // ---------- 全画面ローディング（検索・絞り込みの待ち時間を可視化） ----------
  var loadingEl = null;
  function showLoading(text) {
    if (!loadingEl) {
      loadingEl = document.createElement('div');
      loadingEl.id = 'mfct-loading';
      loadingEl.setAttribute('role', 'status');
      var box = document.createElement('div');
      box.className = 'mfct-loading__box';
      var spin = document.createElement('div');
      spin.className = 'mfct-loading__spinner';
      var label = document.createElement('p');
      label.className = 'mfct-loading__text';
      box.appendChild(spin);
      box.appendChild(label);
      loadingEl.appendChild(box);
      document.body.appendChild(loadingEl);
    }
    loadingEl.querySelector('.mfct-loading__text').textContent = text || '読み込み中…';
    loadingEl.hidden = false;
  }
  function hideLoading() {
    if (loadingEl) loadingEl.hidden = true;
  }

  // ---------- カード生成（Liquid snippet と同一構造。データは必ず textContent 経由） ----------
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function buildCard(item) {
    var art = el('article', 'mfct-card');
    var a = el('a', 'mfct-card__link');
    a.href = B.article_base + item.handle;
    if (item.image) {
      var th = el('div', 'mfct-card__thumb');
      var img = document.createElement('img');
      if (item.image_fixed) {
        // 外部CDN（PR TIMES等）の本文画像: widthパラメータ非対応のため素のURL
        img.src = item.image;
      } else {
        var sep = item.image.indexOf('?') >= 0 ? '&' : '?';
        img.src = item.image + sep + 'width=480';
        img.srcset = item.image + sep + 'width=480 480w, ' + item.image + sep + 'width=960 960w';
        img.sizes = '(max-width: 640px) 100vw, 480px';
      }
      img.alt = ''; img.loading = 'lazy'; img.width = 320; img.height = 180; // 追記カードは常に画面外なのでlazyでよい
      th.appendChild(img); a.appendChild(th);
    }
    var body = el('div', 'mfct-card__body');
    var meta = el('div', 'mfct-card__meta');
    if (item.kind) meta.appendChild(el('span', 'mfct-card__kind', item.kind));
    if (item.date) {
      var t = document.createElement('time');
      t.dateTime = item.date; t.textContent = item.date.replace(/-/g, '/');
      meta.appendChild(t);
    }
    body.appendChild(meta);
    var ev = item.event;
    if (ev) {
      var evd = el('div', 'mfct-card__event');
      if (ev.upcoming) evd.appendChild(el('span', 'mfct-event__badge', '開催予定'));
      if (ev.label) evd.appendChild(el('span', 'mfct-event__date', ev.label));
      if (ev.format_label) evd.appendChild(el('span', 'mfct-event__format', ev.format_label));
      if (ev.price_label) evd.appendChild(el('span', 'mfct-event__price', ev.price_label));
      body.appendChild(evd);
    }
    body.appendChild(el('h3', 'mfct-card__title', item.title));
    if (item.excerpt) body.appendChild(el('p', 'mfct-card__excerpt', item.excerpt));
    if (item.tags && item.tags.length) {
      var tg = el('div', 'mfct-card__tags');
      item.tags.forEach(function (x) { tg.appendChild(el('span', 'mfct-tag', x)); });
      body.appendChild(tg);
    }
    a.appendChild(body);
    art.appendChild(a);
    return art;
  }

  // ---------- csr-index の遅延取得（1回だけ・失敗してもSSRは温存） ----------
  // fetch+本文読了の総時間上限。fetch の Promise はヘッダ受信時点で解決するため、
  // race の対象は必ず r.json()（本文読了）まで含める（本文途中で止まる接続でも30秒で必ず解除）。
  // AbortController がある環境ではネットワーク要求自体も中断する。成功時は timer を必ず clear。
  function fetchJsonWithDeadline(url, label) {
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer;
    var timeout = new Promise(function (_, reject) {
      timer = setTimeout(function () {
        if (controller) { try { controller.abort(); } catch (e) { /* noop */ } }
        reject(new Error(label + ' timeout (30s)'));
      }, 30000);
    });
    var work = fetch(url, { credentials: 'same-origin', signal: controller ? controller.signal : undefined })
      .then(function (r) {
        if (!r.ok) throw new Error(label + ' HTTP ' + r.status);
        return r.json();
      });
    return Promise.race([work, timeout]).finally(function () { clearTimeout(timer); });
  }
  // シャードローダ: index_urls[0]=シャード1（items + 全記事のtail{f,d}）、以降は items のみ。
  // 各シャードは1回だけfetchしてキャッシュ（失敗時はキャッシュを消して次回再試行可能に）
  var shardUrls = B.index_urls || [];
  var shardCache = new Array(shardUrls.length);
  function loadShard(i) {
    if (!shardCache[i]) {
      shardCache[i] = fetchJsonWithDeadline(shardUrls[i], 'index' + (i + 1))
        .then(function (idx) {
          var ok = idx && idx.schema_version === 3 && idx.type === B.type && Array.isArray(idx.items)
            && (i === 0 ? Array.isArray(idx.tail) : idx.shard === i + 1);
          if (!ok) throw new Error('index schema mismatch (shard ' + (i + 1) + ')');
          return idx;
        })
        .catch(function (e) { shardCache[i] = null; throw e; });
    }
    return shardCache[i];
  }
  function loadIndex() { return loadShard(0); }
  var activeSlugs = (B.filters || []).map(function (f) { return f.slug; });
  function matchesPage(item) {
    if (activeSlugs.length === 0) return true;
    return (item.f || []).some(function (s) { return activeSlugs.indexOf(s) >= 0; });
  }

  // ---------- 無限スクロール ----------
  var shownHandles = Object.create(null);
  var shown = 0; // 表示済み件数
  (B.items || []).slice(0, B.per_page).forEach(function (it) { shownHandles[it.handle] = 1; shown++; });
  var tailItems = [];     // index由来の続きリスト（フィルタ・重複除去済み・シャード毎に追加）
  var tailPos = 0;
  var tailShard = 0;      // 次に読み込むシャード番号（0-based）
  var exhausted = false;
  var appending = false;
  var indexFailures = 0;  // 連続失敗で打ち切る（?p=復元ループ等での無限リトライ防止）
  var batchStarts = [];   // 各バッチ先頭のcard要素（?p=ビューポート連動用）
  batchStarts.push(grid.firstElementChild);

  function appendFrom(list, start, count) {
    var frag = document.createDocumentFragment();
    var added = 0;
    var first = null;
    for (var i = start; i < list.length && added < count; i++) {
      var it = list[i];
      if (shownHandles[it.handle]) continue;
      var c = buildCard(it);
      if (!first) first = c;
      frag.appendChild(c);
      shownHandles[it.handle] = 1;
      added++;
    }
    if (added > 0) {
      grid.appendChild(frag);
      batchStarts.push(first);
      shown += added;
    }
    return added;
  }

  function markExhausted() {
    exhausted = true;
    if (shown < B.total && listNote) {
      listNote.textContent = '最新' + shown + '件までを表示しています（全' + B.total + '件）。';
      listNote.hidden = false;
    }
  }

  function appendBatch() {
    if (appending || exhausted || csrActive) return;
    appending = true;
    var embedded = B.items || [];
    // 1) bootstrap埋め込み分
    var embeddedNext = [];
    for (var i = 0; i < embedded.length; i++) if (!shownHandles[embedded[i].handle]) embeddedNext.push(embedded[i]);
    if (embeddedNext.length > 0) {
      appendFrom(embeddedNext, 0, B.per_page);
      finishAppend();
      return;
    }
    if (shown >= B.total) { exhausted = true; appending = false; return; }
    // 2) csr-index の続き（シャードを順にfetchして全件までスクロール可能）
    if (tailPos < tailItems.length) {
      var added0 = appendFrom(tailItems, tailPos, B.per_page);
      tailPos += added0;
      while (tailPos < tailItems.length && shownHandles[tailItems[tailPos].handle]) tailPos++;
      if (added0 === 0 && tailShard >= shardUrls.length) markExhausted();
      finishAppend();
      return;
    }
    if (tailShard >= shardUrls.length) { markExhausted(); appending = false; return; }
    var loadingShard = tailShard;
    loadShard(loadingShard).then(function (idx) {
      if (loadingShard === tailShard) {
        tailShard++;
        var fresh = (idx.items || []).filter(function (it) { return matchesPage(it) && !shownHandles[it.handle]; });
        tailItems = tailItems.concat(fresh);
      }
      indexFailures = 0;
      appending = false;
      appendBatch(); // 続きから追記（このシャードが空振りなら次シャードへ）
    }).catch(function (e) {
      log('index取得失敗', e);
      appending = false;
      indexFailures++;
      if (indexFailures >= 3) {
        // 恒久障害（404/スキーマ不一致等）とみなして打ち切る（?p=復元ループの無限リトライ防止）
        exhausted = true;
        if (statusEl) statusEl.textContent = '続きの読み込みに失敗しました。再読み込みしてください。';
      }
    });
  }
  function finishAppend() {
    appending = false;
    updateUrlP();
    // 画面が埋まっていなければ連鎖追記（大画面対策）
    setTimeout(function () { if (nearSentinel()) appendBatch(); }, 50);
  }

  function nearSentinel() {
    var r = sentinel.getBoundingClientRect();
    if (r.top === 0 && r.bottom === 0) {
      var g = grid.getBoundingClientRect();
      return g.bottom < window.innerHeight + 600;
    }
    return r.top < window.innerHeight + 600;
  }

  // IO（主経路）: 通常一覧とCSR結果それぞれのsentinelを監視し、状態に応じて追記先を振り分ける
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        if (csrActive) csrAppendBatch();
        else appendBatch();
      });
    }, { rootMargin: '600px 0px' });
    io.observe(sentinel);
    if (csrSentinel) io.observe(csrSentinel);
  }
  // フォールバック（scroll/resize・150ms節流）
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    setTimeout(function () {
      ticking = false;
      if (csrActive) {
        if (nearCsrSentinel()) csrAppendBatch();
        return;
      }
      if (nearSentinel()) appendBatch();
      updateUrlP();
    }, 150);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  // 初期表示時チェック: 画面が大きくSSR分でビューポートが埋まらない場合、
  // スクロールイベントが一度も起きずIOも不発だと永久に追記されないため、ロード直後に一度判定する
  setTimeout(function () { if (nearSentinel()) appendBatch(); }, 0);
  window.addEventListener('load', function () { if (nearSentinel()) appendBatch(); });

  // ---------- ?p= ビューポート連動 ----------
  function currentBatch() {
    var mid = window.innerHeight / 2;
    var cur = 1;
    for (var i = 1; i < batchStarts.length; i++) {
      var elm = batchStarts[i];
      if (!elm) continue;
      if (elm.getBoundingClientRect().top <= mid) cur = i + 1;
    }
    return cur;
  }
  var lastP = null;
  var restoringP = false; // ?p=N 直開きの展開中はURL書き換えを抑止（展開はスクロール位置0のまま進むため）
  function updateUrlP() {
    if (csrActive || restoringP) return;
    var p = currentBatch();
    if (p === lastP) return;
    lastP = p;
    try {
      var u = new URL(window.location.href);
      if (p <= 1) u.searchParams.delete('p'); else u.searchParams.set('p', String(p));
      history.replaceState(history.state, '', u.toString());
    } catch (e) { /* URL非対応環境では何もしない */ }
  }

  // ?p=N 直開き: Nバッチぶん展開して該当位置へ
  (function restoreP() {
    var p = 0;
    try { p = parseInt(new URL(window.location.href).searchParams.get('p') || '0', 10) || 0; } catch (e) { return; }
    if (p <= 1) return;
    var target = Math.min(p, 50); // 暴走防止
    restoringP = true;
    var attempts = 0;
    (function step() {
      // attempts は「appendBatch を実際に起動できた回数」だけ数える
      // （通信待ち中 appending=true の間はカウントしない=遅い回線で早期終了しない。
      //   恒久障害は appendBatch 側の連続失敗打ち切り(exhausted)がこのループも終える）
      if (batchStarts.length >= target || exhausted || attempts > 60) {
        var elm = batchStarts[Math.min(target, batchStarts.length) - 1];
        if (elm) elm.scrollIntoView();
        restoringP = false;
        updateUrlP();
        return;
      }
      if (!appending) {
        attempts++;
        appendBatch();
      }
      setTimeout(step, 120);
    })();
  })();

  // ---------- 絞り込み（タグ=AND + フリーワード + 期間 + 開催予定） ----------
  var boxes = [].slice.call(document.querySelectorAll('#mfct-filter-groups input[type="checkbox"]'));
  var resetBtn = document.getElementById('mfct-filter-reset');
  var qInput = document.getElementById('mfct-q');
  var dSelect = document.getElementById('mfct-d');
  var uCheck = document.getElementById('mfct-u');
  var csrActive = false;
  var generation = 0;

  function currentDays() {
    var v = dSelect ? parseInt(dSelect.value, 10) : 0;
    return Number.isFinite(v) && v > 0 ? v : 0;
  }
  function currentUpcoming() {
    return !!(uCheck && uCheck.checked);
  }
  // JST基準で「今日を含む days 日以内」のカットオフ日（YYYY-MM-DD）
  function cutoffOf(days) {
    if (!days) return null;
    return new Date(Date.now() + 9 * 3600000 - (days - 1) * 86400000).toISOString().slice(0, 10);
  }
  // 現在のUI状態を条件オブジェクトへ
  function currentFilter() {
    var q = currentQuery();
    return {
      slugs: selectedSlugs(),
      q: q,
      terms: queryTerms(q),
      days: currentDays(),
      cutoff: cutoffOf(currentDays()),
      upcoming: currentUpcoming(),
    };
  }
  function isPlainState(F) { // CSRが不要な状態（通常のSSR/ページ遷移で表現できる）
    return !F.q && !F.days && !F.upcoming;
  }
  // カード（items）に対する完全判定
  function itemMatches(it, F) {
    if (!matchesTagsAnd(it.f, F.slugs)) return false;
    if (F.cutoff && !(it.date && it.date >= F.cutoff)) return false;
    if (F.upcoming && !(it.event && it.event.upcoming && !it.event.low_confidence)) return false;
    for (var i = 0; i < F.terms.length; i++) {
      if (itemText(it).indexOf(F.terms[i]) < 0) return false;
    }
    return true;
  }
  // tail行（{f,d}のみ）に対する判定。キーワード・開催予定はtailでは判定できない
  function tailMatches(row, F) {
    if (!matchesTagsAnd(row.f || [], F.slugs)) return false;
    if (F.cutoff && !(row.d && row.d >= F.cutoff)) return false;
    return true;
  }

  function currentQuery() {
    return qInput ? qInput.value.normalize('NFC').trim() : '';
  }
  // 空白区切りの各語をすべて含む（語間AND）。過剰入力は8語で打ち切り
  function queryTerms(q) {
    return q.toLowerCase().split(/\s+/).filter(Boolean).slice(0, 8);
  }
  // 検索対象テキスト（タイトル+リード文+タグ。小文字NFCをitemにキャッシュ）
  function itemText(it) {
    if (it._txt === undefined) {
      it._txt = ((it.title || '') + ' ' + (it.excerpt || '') + ' ' + (it.tags || []).join(' ')).normalize('NFC').toLowerCase();
    }
    return it._txt;
  }
  function matchesTagsAnd(f, slugs) {
    for (var i = 0; i < slugs.length; i++) {
      if (!f || f.indexOf(slugs[i]) < 0) return false;
    }
    return true;
  }

  // プログラム遷移では下書きテーマの preview パラメータ（preview_theme_id / key）を引き継ぐ
  // （落とすと遷移先が公開テーマで描画され、検証中のページ遷移確認ができなくなる）
  function navigateTo(handle) {
    var dest = B.base + handle;
    try {
      var cur = new URL(window.location.href);
      var u = new URL(dest, window.location.origin);
      ['preview_theme_id', 'key', '_fd', 'pb'].forEach(function (k) {
        var v = cur.searchParams.get(k);
        if (v !== null) u.searchParams.set(k, v);
      });
      dest = u.pathname + u.search;
    } catch (e) { /* URL非対応環境は素のパスで遷移 */ }
    window.location.href = dest;
  }

  function selectedSlugs() {
    return boxes.filter(function (b) { return b.checked; }).map(function (b) { return b.getAttribute('data-slug'); });
  }

  function showSsr() {
    csrActive = false;
    if (csrWrap) csrWrap.hidden = true;
    if (ssrWrap) ssrWrap.hidden = false;
    if (statusEl) statusEl.textContent = '';
    try {
      var u = new URL(window.location.href);
      u.searchParams.delete('f');
      u.searchParams.delete('q');
      u.searchParams.delete('d');
      u.searchParams.delete('u');
      history.replaceState(history.state, '', u.toString());
    } catch (e) { /* noop */ }
  }

  function filterLabel(F, count) {
    var parts = [];
    if (F.slugs.length) parts.push('選択したタグすべて');
    if (F.terms.length) parts.push('「' + F.q + '」');
    if (F.days) parts.push(F.days + '日以内');
    if (F.upcoming) parts.push('開催予定（確認済み）');
    return (parts.join(' + ') || '全件') + 'に該当: ' + count + '件';
  }

  // 全記事が対象のCSR絞り込み。結果は無限スクロールで表示（表示件数の上限なし）。
  // - タグ/期間のみ: 件数はシャード1の items+tail から即時に全件集計。カードはスクロールに応じてシャードを遅延fetch
  // - キーワード/開催予定を含む: 判定にカード情報が必要なため、全シャードをロード（全画面ローディングで進捗表示）
  var csrState = null; // {gen, F, hits[], pos, shardNext, needAll}
  function renderCsr(F) {
    var gen = ++generation;
    csrActive = true;
    var needAllShards = F.terms.length > 0 || F.upcoming;
    var shardCount = Math.max(1, shardUrls.length);
    showLoading(needAllShards && shardCount > 1 ? '検索中… (1/' + shardCount + ')' : '絞り込み中…');

    var hits = [];
    var idx1ref = null;

    function finish() {
      if (gen !== generation) return;
      var exact;
      if (needAllShards) {
        exact = hits.length;
      } else {
        // タグ/期間のみ: シャード1の items + tail（全記事の{f,d}）から全件を即時集計
        exact = (idx1ref.items || []).filter(function (it) { return itemMatches(it, F); }).length;
        for (var j = 0; j < (idx1ref.tail || []).length; j++) {
          if (tailMatches(idx1ref.tail[j], F)) exact++;
        }
      }
      csrState = { gen: gen, F: F, hits: hits, pos: 0, shardNext: needAllShards ? shardCount : 1, needAll: needAllShards, exact: exact };
      csrGrid.textContent = '';
      if (csrNote) csrNote.textContent = filterLabel(F, exact);
      if (ssrWrap) ssrWrap.hidden = true;
      if (csrWrap) csrWrap.hidden = false;
      if (statusEl) statusEl.textContent = '';
      hideLoading();
      csrAppendBatch(); // 先頭バッチ描画（以降はスクロールで追記）
      try {
        var u = new URL(window.location.href);
        if (F.slugs.length) u.searchParams.set('f', F.slugs.join(' '));
        else u.searchParams.delete('f');
        if (F.q) u.searchParams.set('q', F.q);
        else u.searchParams.delete('q');
        if (F.days) u.searchParams.set('d', String(F.days));
        else u.searchParams.delete('d');
        if (F.upcoming) u.searchParams.set('u', '1');
        else u.searchParams.delete('u');
        u.searchParams.delete('p');
        history.replaceState(history.state, '', u.toString());
      } catch (e) { /* noop */ }
    }

    (function step(s) {
      if (gen !== generation) { hideLoading(); return; }
      loadShard(s).then(function (idx) {
        if (gen !== generation) { hideLoading(); return; }
        if (s === 0) idx1ref = idx;
        var items = idx.items || [];
        for (var i = 0; i < items.length; i++) {
          if (itemMatches(items[i], F)) hits.push(items[i]);
        }
        // キーワード/開催予定は全シャード必須。タグ/期間のみはシャード1で開始（続きはスクロールで遅延）
        if (needAllShards && s + 1 < shardCount) {
          showLoading('検索中… (' + (s + 2) + '/' + shardCount + ')');
          step(s + 1);
        } else {
          finish();
        }
      }).catch(function (e) {
        if (gen !== generation) { hideLoading(); return; }
        log('csr失敗', e);
        csrActive = false;
        hideLoading();
        if (statusEl) statusEl.textContent = '絞り込みに失敗しました。通常の一覧を表示しています。';
        if (ssrWrap) ssrWrap.hidden = false;
        if (csrWrap) csrWrap.hidden = true;
      });
    })(0);
  }

  // CSR結果の無限スクロール追記。hits を使い切ったら（タグ/期間のみの場合）次のシャードを遅延fetchして継続
  var csrAppending = false;
  function csrAppendBatch() {
    if (!csrActive || !csrState || csrAppending) return;
    var st = csrState;
    if (st.pos < st.hits.length) {
      var frag = document.createDocumentFragment();
      var end = Math.min(st.pos + B.per_page, st.hits.length);
      for (var i = st.pos; i < end; i++) frag.appendChild(buildCard(st.hits[i]));
      st.pos = end;
      csrGrid.appendChild(frag);
      return;
    }
    if (st.needAll || st.shardNext >= Math.max(1, shardUrls.length)) return; // 全件描画済み
    csrAppending = true;
    var s = st.shardNext;
    loadShard(s).then(function (idx) {
      csrAppending = false;
      if (!csrActive || csrState !== st || st.gen !== generation) return;
      st.shardNext = s + 1;
      var items = idx.items || [];
      for (var i = 0; i < items.length; i++) {
        if (itemMatches(items[i], st.F)) st.hits.push(items[i]);
      }
      csrAppendBatch(); // 取得分を描画（このシャードが空振りなら次へ）
    }).catch(function (e) {
      csrAppending = false;
      log('csr続き失敗', e);
      if (statusEl) statusEl.textContent = '続きの読み込みに失敗しました。';
    });
  }
  function nearCsrSentinel() {
    if (!csrSentinel) {
      var g = csrGrid.getBoundingClientRect();
      return g.bottom < window.innerHeight + 600;
    }
    var r = csrSentinel.getBoundingClientRect();
    if (r.top === 0 && r.bottom === 0) {
      var g2 = csrGrid.getBoundingClientRect();
      return g2.bottom < window.innerHeight + 600;
    }
    return r.top < window.innerHeight + 600;
  }

  var navigating = false;
  function onSelectionChange() {
    if (navigating) return;
    // どの分岐に入る場合も先に世代を進める（旧manifest応答が「解除後の遷移」を起こす競合の防止）
    var gen = ++generation;
    var F = currentFilter();
    // キーワード・期間・開催予定のいずれかが有効ならページ遷移しない（条件が失われる）→ 常にその場CSR
    if (!isPlainState(F)) {
      renderCsr(F);
      return;
    }
    if (F.slugs.length === 0) {
      if (activeSlugs.length > 0) { navigating = true; navigateTo(B.top_handle); return; }
      showSsr();
      return;
    }
    if (F.slugs.length === 1) {
      var handle = B.top_handle + '-' + F.slugs[0];
      if (handle === B.handle) { showSsr(); return; }
      fetchJsonWithDeadline(B.manifest_url, 'manifest')
        .then(function (m) {
          if (gen !== generation) return;
          // manifest取得中に他の条件が入力された場合は遷移せずCSRへ（入力を失わない）
          if (!isPlainState(currentFilter())) { onSelectionChange(); return; }
          if (m.handles && m.handles[handle]) {
            navigating = true;
            navigateTo(handle);
          } else {
            renderCsr(F);
          }
        })
        .catch(function () { if (gen === generation) renderCsr(F); });
      return;
    }
    renderCsr(F);
  }
  boxes.forEach(function (b) { b.addEventListener('change', onSelectionChange); });
  if (dSelect) dSelect.addEventListener('change', onSelectionChange);
  if (uCheck) uCheck.addEventListener('change', onSelectionChange);
  if (qInput) {
    var qTimer = null;
    qInput.addEventListener('input', function () {
      clearTimeout(qTimer);
      qTimer = setTimeout(onSelectionChange, 300); // 300ms デバウンス
    });
    qInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        clearTimeout(qTimer);
        onSelectionChange();
      }
    });
  }
  if (resetBtn) {
    resetBtn.addEventListener('click', function () {
      boxes.forEach(function (b) { b.checked = false; });
      if (qInput) qInput.value = '';
      if (dSelect) dSelect.value = '';
      if (uCheck) uCheck.checked = false;
      onSelectionChange();
    });
  }

  // ?f= / ?q= / ?d= / ?u= 復元（SSRのactiveチェックは一旦解除してから復元）
  // f は既知slugとの積集合 + 重複排除 + 上限で正規化する（?f=ai+ai や未知slugの共有URLで挙動が壊れないように）
  (function restoreState() {
    var f = null;
    var q = '';
    var d = 0;
    var uFlag = false;
    try {
      var sp = new URL(window.location.href).searchParams;
      f = sp.get('f');
      q = (sp.get('q') || '').normalize('NFC').trim().slice(0, 100);
      d = parseInt(sp.get('d') || '0', 10) || 0;
      uFlag = sp.get('u') === '1';
    } catch (e) { return; }
    if (!f && !q && !d && !uFlag) return;
    var known = Object.create(null); // プロトタイプキー（constructor等のslug）を誤判定しない
    boxes.forEach(function (b) { known[b.getAttribute('data-slug')] = 1; });
    var seen = Object.create(null);
    var slugs = (f || '').split(/[+\s]+/).filter(function (s) {
      if (!s || !known[s] || seen[s]) return false;
      seen[s] = 1;
      return true;
    }).slice(0, 10);
    boxes.forEach(function (b) { b.checked = slugs.indexOf(b.getAttribute('data-slug')) >= 0; });
    if (qInput) qInput.value = q;
    if (dSelect) {
      // selectに存在する値だけ受理（?d=999 等は全期間扱い）
      var opt = [].slice.call(dSelect.options).some(function (o) { return o.value === String(d); });
      dSelect.value = opt ? String(d) : '';
    }
    if (uCheck) uCheck.checked = uFlag;
    var F = currentFilter();
    if (!F.slugs.length && isPlainState(F)) {
      // 有効な条件が無い共有URL: パラメータを外して通常表示
      showSsr();
      return;
    }
    if (!isPlainState(F) || F.slugs.length >= 2) renderCsr(F);
    else onSelectionChange();
  })();

  log('init', B.handle, 'total', B.total);
})();

/* 記事下リンク集のタブ切替。メインIIFEとは独立（bootstrap不在ページでも動く・非JS時は全パネル表示のまま） */
(function () {
  'use strict';
  var root = document.querySelector('.mfct-garden');
  if (!root) return;
  var tabs = [].slice.call(root.querySelectorAll('.mfct-garden__tab'));
  var panels = [].slice.call(root.querySelectorAll('.mfct-garden__panel'));
  if (!tabs.length || !panels.length) return;
  function show(key) {
    tabs.forEach(function (t) {
      var active = t.getAttribute('data-gtab') === key;
      t.setAttribute('aria-selected', active ? 'true' : 'false');
      // roving tabindex（role="tab" のARIAパターン: Tabキーはアクティブタブのみ・左右移動は矢印キー）
      t.tabIndex = active ? 0 : -1;
    });
    panels.forEach(function (p) {
      if (p.getAttribute('data-gpanel') === key) p.removeAttribute('hidden');
      else p.setAttribute('hidden', '');
    });
  }
  var initial = null;
  tabs.forEach(function (t, i) {
    if (t.getAttribute('aria-selected') === 'true') initial = t.getAttribute('data-gtab');
    t.addEventListener('click', function () { show(t.getAttribute('data-gtab')); });
    t.addEventListener('keydown', function (e) {
      var k = e.key || e.keyCode;
      var dir = (k === 'ArrowRight' || k === 39) ? 1 : (k === 'ArrowLeft' || k === 37) ? -1 : 0;
      if (!dir) return;
      e.preventDefault();
      var next = tabs[(i + dir + tabs.length) % tabs.length];
      show(next.getAttribute('data-gtab'));
      next.focus();
    });
  });
  show(initial || tabs[0].getAttribute('data-gtab'));
})();
